import { render, staticRenderFns } from "./SpuOnSale.vue?vue&type=template&id=73d28b55&scoped=true&"
import script from "./SpuOnSale.vue?vue&type=script&lang=js&"
export * from "./SpuOnSale.vue?vue&type=script&lang=js&"
import style0 from "./SpuOnSale.vue?vue&type=style&index=0&id=73d28b55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d28b55",
  null
  
)

component.options.__file = "SpuOnSale.vue"
export default component.exports